module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/200-south-africa-ed01d87926bdedc4699d5872afd4a40f.svg";